import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}
export function CTAButton({
  className = '',
  onClick,
  children
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} className={`group relative inline-flex items-center justify-center gap-3 bg-coral-500 hover:bg-coral-600 text-white font-sans font-bold text-lg md:text-xl py-4 px-8 md:px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden ${className}`} onClick={e => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('oferta')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }} data-id="element-181">
      <span className="relative z-10" data-id="element-182">
        {children || 'SÍ, QUIERO DESINFLAMARME AHORA'}
      </span>
      <ArrowRight className="w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-183" />
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-184" />
    </motion.button>;
}